import * as React from 'react';
import {Card, Typography, notification, Spin, Space, Row, Col, Button} from 'antd';
import {
  ClockCircleOutlined,
  HeartFilled,
  ShareAltOutlined,
} from '@ant-design/icons';
import './index.scss';
import API_SERVICE from 'shared/services/api-service';
import {useTranslation} from 'react-i18next';
import {Redirect, useHistory} from 'react-router-dom';
import {AuthConsumer} from 'shared/contexts/AuthContext';
import {useState} from 'react';
// @ts-ignore
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Parameters from 'shared/parameters';
import Paragraph from 'antd/es/typography/Paragraph';
import Title from 'antd/es/typography/Title';
import starGolden from '../../../img/star-golden.png';
import starBlue from '../../../img/star-blue.png';

const {Text} = Typography;
export default function ProductCard({item, refresh}: any) {
  const {t} = useTranslation();
  const history = useHistory();
  const getDuration = () => {
    let durationInMinutes = 0;
    if (item) {
      if (item.duration) {
        return item.duration;
      }
      if (item.curriculums) {
        item.curriculums.forEach((c: any) => {
          c.contents.forEach((content: any) => {
            durationInMinutes += parseInt(content.duration_in_minutes);
          });
        });
      }
    }
    return durationInMinutes;
  };
  return <><div className='col-lg-4 col-md-6 col-sm-12 mb-4'>
    <div className='bg-white'>
      <div className='shadow br-5px'>
        <div className='pos-relative'>

          <img src={Parameters.ImageBaseUrl + item.thumbnail.slug + item.thumbnail.ext}
            className="img-fluid w-100 cursor-pointer" style={{ height: '185px', objectFit: 'cover' }}
            onClick={() => {
              history.push('/courses/' + item.id);
            } } />
          <div className='bottom-right'>
            {(item.isCompleted || item.is_completed) && <Button onClick={
          async (e) => {
            e.preventDefault();
            e.stopPropagation();
            try {
              const { data: { data: { link } } } = await API_SERVICE.certificate(item.id);
              window.open(link);
            } catch (e) {
              console.log(e);
            }
          } }>{t('genDict.certificate')}</Button>}
          </div>
          <div className='top-right'>
            {item.is_popular ? <span className="labeled recommend small d-flex align-items-center"><img src={starGolden} style={{ width: '13px' }} />&nbsp;Popular</span> : ''}
            {item.is_featured ? <span className="labeled featured small d-flex align-items-center"><img src={starBlue} style={{ width: '13px' }} />&nbsp;Featured</span> : ''}
          </div>
          <div className='top-left'>
            {item?.level?.name && <span className="labeled featured small d-flex align-items-center" style={{padding: '0px 10px'}}>{item.level.name}</span>} 
          </div>
        </div>
        <div className='p-2'>
          {console.log('itemmm', item)}
          <h5 className=''>{item.title}</h5>
          <p className='small text-secondary mb-1'>
            <span>by {item.author.name}</span>

            {/* {item.status === 'INACTIVE' ? <span className='float-right btn-switch'>
              <input type="checkbox" id="checkbox1" disabled />
              <label htmlFor="checkbox1"></label>
            </span> :
              <span className='float-right btn-switch'>
                <input type="checkbox" id="checkbox1" checked disabled />
                <label htmlFor="checkbox1"></label>
              </span>} */}
          </p>
          <p className='small mb-1 text-4f46e5'>Enrolled</p>
          <div className='d-flex align-items-center justify-content-space-between'>
            <div>
              <ul className='list-style-none d-flex align-items-center' style={{ flexWrap: 'nowrap' }}>
                {item.course_users && item.course_users.slice(0, 5).map((courseUser: any, sIndex: any) => {

                  return <>
                    {courseUser.avatar_image ?
                      <li className='li-enrolled-img'>
                        <img src={Parameters.ImageBaseUrl + courseUser.avatar_image.slug + courseUser.avatar_image.ext} className='img-enrolled' />
                      </li>
                      : <li className='li-enrolled-img'>
                        <img src={Parameters.ImageBaseUrl + 'avatar.png'} className='img-enrolled' />
                      </li>}
                  </>;
                })}
                {item.course_users.length <= 0 ?

                  <><li className='small text-4f46e5 ml-2'><img src={Parameters.ImageBaseUrl + 'user-icon.jpg'} className='img-enrolled' /> + {0}</li></>
                  :
                  ''}
                {item.course_users.length > 5 ?
                  <li className='small text-4f46e5 ml-2'> + {item.course_users.length - 5}</li>
                  : ''}
              </ul>
            </div>
            {/* <div>
              <h6 className="price">${item.sale_price}</h6>
            </div> */}
          </div>
          {/* <div className='mt-3 mb-3'>
            <Space>
              <FavouriteButton item={item} refresh={refresh} />
              <div onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              } }>
                <CopyToClipboard text={window.location.origin + '/courses/' + item.id}
                  onCopy={(e: any) => {
                    notification.success({ message: t('course.linkCopiedSuccessFully') });
                  } }>
                  <ShareAltOutlined key="share" />
                </CopyToClipboard>
              </div>
            </Space>
          </div> */}
          <div className='mt-2'>
            <ul className='list-style-none d-flex justify-content-space-between'>
              <li className='text-center small text-secondary'>
                <span>Module</span><br></br>
                <span>{item?.modules ? item.modules : <></>}</span>
              </li>
              <li className='text-center small text-secondary'>
                <span>Lectures</span><br></br>
                <span>{item.lectures_count}</span>
              </li>
              <li className='text-center small text-secondary'>
                <span>Assignment</span><br></br>
                <span>{item.assignments_count}</span>
              </li>
              {/* <li className='text-center small text-secondary'>
                <span>Duration</span><br></br>
                <span>{item.duration_in_minutes} minute</span>
              </li> */}
            </ul>
          </div>
        </div>
        <div>
          <button className="btn btn-blue w-100" onClick={() => {
              history.push('/courses/' + item.id);
            } }>More Details</button>
        </div>
      </div>
    </div>
  </div>
  {/* <Col lg={6} md={8} sm={12} xs={24}><Card
    onClick={() => {
      history.push('/courses/' + item.id);
    } }
    className={'product-card'}
    cover={item.thumbnail && <div className={'image-thumbnail'}
      style={{ backgroundImage: `url(${Parameters.ImageBaseUrl + item.thumbnail.slug + item.thumbnail.ext})` }}>
      {(item.isCompleted || item.is_completed) && <Button onClick={
        async (e) => {
          e.preventDefault();
          e.stopPropagation();
          try {
            const { data: { data: { link } } } = await API_SERVICE.certificate(item.id);
            window.open(link);
          } catch (e) {
            console.log(e);
          }
        } }>{t('genDict.certificate')}</Button>}
    </div>}
  >

    <div className="details-section">
      <Paragraph ellipsis={{ rows: 1 }} className={'product-name'}>
        {item.category.name}
      </Paragraph>
      <div style={{ textAlign: 'left' }}>
        <Title style={{ textAlign: 'left' }} level={4}>
          {item.title}
        </Title>
      </div>

      <Paragraph ellipsis={{ rows: 2 }} className={'author-name'}>
        {t('genDict.by')}: {item.author.name}
      </Paragraph>
      <div className="price">
        <Space size={5} align={'center'}>
          <Text className={'product-price'}>${item.sale_price}</Text> <Text delete type='danger'>${item.price}</Text>
        </Space>
      </div>
      <Row justify={'space-between'}>
        <Col>
          <Space>
            <FavouriteButton item={item} refresh={refresh} />
            <div onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            } }>
              <CopyToClipboard text={window.location.origin + '/courses/' + item.id}
                onCopy={(e: any) => {
                  notification.success({ message: t('course.linkCopiedSuccessFully') });
                } }>
                <ShareAltOutlined key="share" />
              </CopyToClipboard>
            </div>
          </Space>
        </Col>
        <Col>
          {getDuration()} min <ClockCircleOutlined key="clock" />

        </Col>
      </Row>

    </div>
  </Card>
    </Col> */}
    </>;
}

function FavouriteButton({item, refresh}: any) {
  const {t} = useTranslation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const toggleFavourite = async () => {
    setLoading(true);
    if (item.wishlist) {
      await API_SERVICE.markCourseNotFav(item.id).then(() => {
        refresh();
        notification.success({message: t('course.removedFromFavSuccessfully')});
      }).catch((e: any) => {
        notification.error({
          message: API_SERVICE.handleErrors(e),
        });
      }).finally(() => {
        setLoading(false);
      });
    } else {
      await API_SERVICE.markFavourite(item.id).then(() => {
        refresh();
        notification.success({message: t('course.addedToFavSuccessfully')});
      }).catch((e: any) => {
        notification.error({
          message: API_SERVICE.handleErrors(e),
        });
      }).finally(() => {
        setLoading(false);
      });
    }
  };
  return loading ? <Spin/> : <AuthConsumer>
    {({isAuth}) => <HeartFilled className={item.wishlist && 'icon-danger'} onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      !isAuth ? history.push('/login') : toggleFavourite();
    }
    } key="heart"/>}
  </AuthConsumer>;

}
